/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Quality_Section1 from "./sections/Quality_Section1";

function Quality() {
  usePageMeta({
    title: "Quality Policy | Spechs Ireland",
    description:
      "Spechs quality policy — our commitment to delivering consistently high standards across all services.",
    canonical: "https://www.spechs.ie/quality/",
  });
  return (
    <SubPageLayout title="Quality Policy Statement">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Quality_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default Quality;
